import { useServices } from '@services/common'
import { useTranslation } from 'react-i18next'

import { Label } from '@/components/ui/label'
import { MultiCombobox } from '@/components/ui/multi-combobox'

interface Props {
  value?: string[]
  onChange: (value: string[]) => void
  disabled?: boolean
}

export function ServicesSelect({ value = [], onChange, disabled }: Props) {
  const { t } = useTranslation('application')
  const { data, isLoading } = useServices({ search: '' })

  const options = (data ?? [])
    .filter((s) => s.id)
    .map((s) => ({ value: s.id!, label: s.name ?? '' }))

  return (
    <div>
      <Label className="mb-1.5 block">{t('services.label')}</Label>
      <MultiCombobox
        value={value}
        onChange={onChange}
        options={options}
        loading={isLoading}
        disabled={disabled}
        placeholder={t('services.placeholder')}
      />
    </div>
  )
}
